import {ApiService} from "../index";
import {APIConfig} from "../../../constants";

const MedicalRecordViewDetails = (medicalRecordId: string) => {
    return ApiService[APIConfig.GET_MEDICAL_RECORD_DETAILS.METHOD](APIConfig.GET_MEDICAL_RECORD_DETAILS.URL(medicalRecordId));
}

const PerformanceRecordViewDetails = (performanceRecordId: string) => {
    return ApiService[APIConfig.GET_PERFORMANCE_RECORD_DETAILS.METHOD](APIConfig.GET_PERFORMANCE_RECORD_DETAILS.URL(performanceRecordId));
}

const GetCasesListLite = () => {
    return ApiService[APIConfig.GET_CASES_LIST_LITE.METHOD](APIConfig.GET_CASES_LIST_LITE.URL);
}

const CasesService = {
    MedicalRecordViewDetails,
    PerformanceRecordViewDetails,
    GetCasesListLite
}

export default CasesService;
